import React, { Component } from 'react';
import './mo.css'

class Mo extends Component {
  render() {
    return (
      <div id="mo">
        <div className="container">
          <div className="row">
            <div className="col-md">
              <ul className="app-download">
                <li>
                  <a href="https://itunes.apple.com/us/app/mobileoffize/id1403158727?mt=8" rel="noopener noreferrer" target="_blank"><img src={require('../../images/App_Store.svg')} alt="app-store"/></a>
                </li>
                <li>
                  <a href="https://play.google.com/store/apps/details?id=com.mobileoffize" rel="noopener noreferrer" target="_blank"><img src={require('../../images/google-play-badge.png')} alt="google-play"/></a>
                </li>
              </ul>
                <div className="mo-header">
                  <div className="mo-bg"></div>
                  <div className="row">
                    <div className="col-md">
                      <h2 className="mo-title">
                        Get MOre Done
                      </h2>
                      <p className="mo-content">
                        MobileOffize is your work ToolKit with chat, task, report and know integrated in one mobile app with an intuitive user experience. Our team is driven by the quest to make your life more convenient and productive at work.
                      </p> 
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mo-item">
                        <img src={require("../../images/mo/mo-icon-1.png")} alt="secure"/>
                        <p>Secure</p>
                        <p>What happens in your<br/>company, stays within <br/> the company</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mo-item">
                        <img src={require("../../images/mo/mo-icon-2.png")} alt="100% reach"/>
                        <p>100% Reach</p>
                        <p>Reach everyone.<br />Anywhere, Anytime,<br />even offline</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="mo-item">
                        <img src={require("../../images/mo/mo-icon-3.png")} alt="quickStart"/>
                        <p>Quick Start</p>
                        <p>Download. Signup.<br /> Invite your team.<br /> And GO.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
}

export default Mo;



// WEBPACK FOOTER //
// ./src/components/Mo/Mo.js